"use client";

import { c as _c } from "react/compiler-runtime";
import { clsx } from "@/helpers/clsx";
import { CSSStyleDeclarationWithTransform, motion, useInView } from "framer-motion";
import Image from "next/image";
import CollaborationImage from "public/_static/images/collaboration.jpg";
import React, { useEffect, useState } from "react";
import { FeatureContainer } from "./BentoBoxComponents";
const collaborators = [{
  src: "/avatars/associate.png",
  name: "Associate",
  className: "border-blue-300"
}, {
  src: "/avatars/cfo.png",
  name: "CFO",
  className: "border-yellow-200"
}, {
  src: "/avatars/partner.png",
  name: "General Partner",
  className: "border-emerald-400"
}, {
  src: "/avatars/legal.png",
  name: "Legal Counsel",
  className: "border-pink-300"
}, {
  src: "/avatars/marketing.png",
  name: "Marketing",
  className: "border-teal-300"
}];
export const Collaboration = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="absolute inset-x-2 bottom-0 top-[120px] rounded-t-lg shadow-md shadow-black/30 md:top-auto"><Image src={CollaborationImage} alt="Collaboration" width={1082} height={884} sizes="50vw" className="fade-bottom pointer-events-none w-full select-none rounded-t-lg border-x border-t border-neutral-800 [--mask-size:50%]" quality={85} /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <FeatureContainer className="cursor-green min-h-[400px] !pb-0">{children}{t1}</FeatureContainer>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export const CollaborationOld = t0 => {
  const $ = _c(21);
  const {
    children
  } = t0;
  const [activeIndex, setActiveIndex] = useState(2);
  const [isPaused, setIsPaused] = useState(true);
  const ref = React.useRef(null);
  const isInView = useInView(ref);
  let t1;
  let t2;
  if ($[0] !== isInView || $[1] !== isPaused) {
    t1 = () => {
      if (!isInView) {
        return;
      }
      if (isPaused) {
        return;
      }
      const interval = setInterval(() => {
        setActiveIndex(_temp);
      }, 4000);
      return () => clearInterval(interval);
    };
    t2 = [isPaused, isInView];
    $[0] = isInView;
    $[1] = isPaused;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  const numElements = collaborators.length;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = index => index * 360 / numElements;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const getAngle = t3;
  let t10;
  let t11;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setIsPaused(true);
    };
    t5 = () => {
      setIsPaused(false);
    };
    t6 = e => {
      const target = e.target as HTMLElement;
      const targetContainer = target.closest(".group") as HTMLElement ?? target;
      const parent = e.currentTarget as HTMLElement;
      if (targetContainer === parent) {
        return;
      }
      const childIndex = Array.from(parent.children).indexOf(targetContainer);
      if (childIndex === -1) {
        return;
      }
      setActiveIndex(childIndex);
    };
    t7 = {
      y: 20,
      opacity: 0
    };
    t8 = {
      y: 0,
      opacity: 1
    };
    t9 = {
      delay: 0.1
    };
    t10 = {
      once: true
    };
    t11 = () => {
      setIsPaused(false);
    };
    $[5] = t10;
    $[6] = t11;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t10 = $[5];
    t11 = $[6];
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
    t7 = $[10];
    t8 = $[11];
    t9 = $[12];
  }
  let t12;
  if ($[13] !== activeIndex) {
    t12 = collaborators.map((collaborator, index_0) => {
      const angle = getAngle(index_0);
      const x = Math.round(105 * Math.cos(angle * Math.PI / 180));
      const y = Math.round(105 * Math.sin(angle * Math.PI / 180));
      return <Collaborator key={collaborator.name} src={collaborator.src} name={collaborator.name} className={collaborator.className} active={index_0 === activeIndex} index={index_0} style={{
        position: "absolute",
        x,
        y,
        zIndex: index_0 === activeIndex ? "2" : "1"
      }} />;
    });
    $[13] = activeIndex;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="pointer-events-none absolute z-[0] aspect-square w-[210px] rounded-full border border-solid border-white/20" />;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== t12) {
    t14 = <motion.div className="group/parent my-auto mt-6 flex flex-1 items-center justify-center -space-x-[12px]" onMouseEnter={t4} onMouseLeave={t5} onMouseOver={t6} initial={t7} whileInView={t8} transition={t9} viewport={t10} onAnimationComplete={t11}>{t12}{t13}</motion.div>;
    $[16] = t12;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== children || $[19] !== t14) {
    t15 = <FeatureContainer className="cursor-green" ref={ref}>{children}{t14}</FeatureContainer>;
    $[18] = children;
    $[19] = t14;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  return t15;
};
const Collaborator = t0 => {
  const $ = _c(20);
  const {
    src,
    name,
    index,
    active,
    alt,
    className,
    style
  } = t0;
  const t1 = style as any;
  const t2 = alt ?? name;
  const t3 = active && "z-[2] scale-[120%] !brightness-100";
  const t4 = active && index % 2 === 0 && "rotate-[10deg]";
  const t5 = active && index % 2 !== 0 && "rotate-[-10deg]";
  let t6;
  if ($[0] !== className || $[1] !== t3 || $[2] !== t4 || $[3] !== t5) {
    t6 = clsx("relative z-50 w-20 rounded-full ring-[4px] ring-bodyBg !brightness-50 transition-all duration-500", className, t3, t4, t5);
    $[0] = className;
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== src || $[6] !== t2 || $[7] !== t6) {
    t7 = <Image src={src} alt={t2} className={t6} width={100} height={100} />;
    $[5] = src;
    $[6] = t2;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = active && "!z-50 opacity-100 duration-300";
  let t9;
  if ($[9] !== t8) {
    t9 = clsx("bg-btn-secondary-dark pointer-events-none absolute bottom-[-5px] left-1/2 flex -translate-x-1/2 translate-y-[34px] flex-col justify-center whitespace-nowrap rounded-lg border border-transparent px-2 py-1 text-center text-[11px] font-semibold uppercase opacity-0 transition-opacity ease-in animate-duration-300", t8);
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== name) {
    t10 = <span className="text-shadow text-shadow bg-gradient-to-b from-neutral-200 to-neutral-400/80 bg-clip-text text-transparent">{name}</span>;
    $[11] = name;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t9) {
    t11 = <span className={t9}>{t10}</span>;
    $[13] = t10;
    $[14] = t9;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t1 || $[17] !== t11 || $[18] !== t7) {
    t12 = <motion.div className="group relative" style={t1}>{t7}{t11}</motion.div>;
    $[16] = t1;
    $[17] = t11;
    $[18] = t7;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  return t12;
};
function _temp(prev) {
  return (prev + 1) % collaborators.length;
}